import React, {useContext} from "react";
import {Colors} from "../colors";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {ScrollView, View} from "react-native";
import MainHeader from "../assets/MainHeader";
import {HeaderComponents, headerHeight} from "../components/CircleSpinner";
import {useFocusEffect} from "@react-navigation/native";
import OrderItem from "../../../rest/jtmc/models/OrderItem";
import {MenuDetails} from "../../../rest/jtmc/models/MenuDetails";
import {OrderContext} from "../../../contexts/OrderContext";
import {ColumnSpace, RowSpace} from "../components/_CommonComponents";
import Text from "../components/Text";
import {MenuActionButtonStyles} from "../styles";
import {
    GamesPageActionButton,
    ProfilePageActionButton,
    ServicesPageActionButton,
    WaiterCallButton
} from "../components/MenuActionsComponents";
import Button from "../components/Button";
import OrderProgressScreenFunction from "../../../components/screen-functions-components/OrderProgressScreenFunction";
import OrderProgressComponents from "../../../components/functional-components/OrderProgressComponents";
import OrderProgressActionView from "../components/OrderProgressActionView";

export default function TakeawayReceipt({route, navigation}: any) {
    const configContext = useContext(AppConfigContext);
    const orderContext = useContext(OrderContext);

    const {menuDetails}: { menuDetails: MenuDetails } = route.params;
    const colors = Colors.instance(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);

    useFocusEffect(() => {
        configContext.setPageTitle("");
        configContext.setIfPageHasHeader(false);
    });

    const orderItems = orderContext.order?.items.map((item, index) => {
        return <OrderItemRow index={index} orderItem={item}/>
    });

    return <OrderProgressScreenFunction>

        <View style={{height: headerHeight, width: "100%"}}>
            <MainHeader style={{position: "absolute", width: "100%"}} height={headerHeight}/>
            <View style={{position: "absolute", width: "100%", height: headerHeight}}>
                <HeaderComponents menuDetails={menuDetails}/>
            </View>
        </View>
        <PageContent>
            <OrderProgressComponents orderContext={orderContext}>

                <View style={{flexDirection: "row"}}>

                    <View style={{
                        flexGrow: 1,
                        flexDirection: "row",
                        borderColor: colors.get("highConText") as string,
                        borderWidth: 1,
                        borderRadius: 4,
                        paddingVertical: 6,
                        paddingHorizontal: 12
                    }}>
                        <View style={{flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%",}}>
                            <Text size={16} color={colors.get("highConText") as string}>شماره فاکتور:</Text>
                            <Text size={26} weight={800}
                                  color={colors.get("highConText") as string}>{orderContext.order?.invoiceCode}</Text>
                        </View>
                    </View>

                    <RowSpace/>

                    <View style={{
                        flexGrow: 1,
                        flexDirection: "column",
                        borderColor: colors.get("highConText") as string,
                        borderWidth: 1,
                        borderRadius: 4,
                        paddingVertical: 6,
                        paddingHorizontal: 12
                    }}>
                        <View style={{flexDirection: "row", justifyContent: "space-between", alignItems: "center"}}>
                            <Text size={16} color={colors.get("highConText") as string}>تاریخ:</Text>
                            <Text size={18} weight={800}
                                  color={colors.get("highConText") as string}>{orderContext.order?.submitDateAndTime().date}</Text>
                        </View>
                        <View style={{flexDirection: "row", justifyContent: "space-between", alignItems: "center"}}>
                            <Text size={16} color={colors.get("highConText") as string}>ساعت:</Text>
                            <Text size={18} weight={800}
                                  color={colors.get("highConText") as string}>{orderContext.order?.submitDateAndTime().time}</Text>
                        </View>
                    </View>

                </View>

                <ColumnSpace/>

                <Text weight={600} role="status-text" color={colors.get("highConText") as string}/>
                <Text weight={600} role="time-text" color={colors.get("highConText") as string}/>
                <ColumnSpace/>
                <ColumnSpace/>

                <HeaderRow/>
                {orderItems}
                <View style={{backgroundColor: colors.get("highConText") as string, width: "100%", height: 2}}/>
                <ColumnSpace/>
                <ColumnSpace/>

                <View style={{flexDirection: "row", alignItems: "center"}}>
                    <Text style={{flexGrow: 2, flexBasis: 0, textAlign: "left"}} color={colors.get("highConText") as string} weight={500} size={14}>
                        جمع کل:
                    </Text>
                    <RowSpace/>
                    <Text style={{flexGrow: 3, flexBasis: 0, textAlign: "center"}} color={colors.get("highConText") as string} weight={700} size={14}>
                        {`${orderContext.order?.cartTotalPrice} تومان`}
                    </Text>
                </View>
                <ColumnSpace/>
                <View style={{flexDirection: "row", alignItems: "center"}}>
                    <Text style={{flexGrow: 2, flexBasis: 0, textAlign: "left"}} color={colors.get("highConText") as string} weight={500} size={14}>
                        جمع تخفیف:
                    </Text>
                    <RowSpace/>
                    <Text style={{flexGrow: 3, flexBasis: 0, textAlign: "center"}} color={colors.get("highConText") as string} weight={700} size={14}>
                        {`${orderContext.order?.totalDiscount} تومان`}
                    </Text>
                </View>
                <ColumnSpace/>
                <View style={{flexDirection: "row", alignItems: "center"}}>
                    <Text style={{flexGrow: 2, flexBasis: 0, textAlign: "left"}} color={colors.get("highConText") as string} weight={500} size={14}>
                        هزینه بسته بندی:
                    </Text>
                    <RowSpace/>
                    <Text style={{flexGrow: 3, flexBasis: 0, textAlign: "center"}} color={colors.get("highConText") as string} weight={700} size={14}>
                        {`${orderContext.order?.totalPackingPrice} تومان`}
                    </Text>
                </View>
                <ColumnSpace/>
                <View style={{flexDirection: "row", alignItems: "center"}}>
                    <Text style={{flexGrow: 2, flexBasis: 0, textAlign: "left"}} color={colors.get("highConText") as string} weight={500} size={14}>
                        قابل پرداخت:
                    </Text>
                    <RowSpace/>
                    <Text style={{flexGrow: 3, flexBasis: 0, textAlign: "center", backgroundColor: "#000", paddingVertical: 4}} color={"#fff"} weight={700} size={18}>
                        {`${orderContext.order?.totalPayablePrice} تومان`}
                    </Text>
                </View>

                <View style={{flexGrow: 1}}/>

                <Button role="back-button"/>

            </OrderProgressComponents>

        </PageContent>

        <OrderProgressActionView optionsAccess={menuDetails.menuOptionsAccess}/>

    </OrderProgressScreenFunction>
}

function PageContent(props: any) {
    return <View style={{
        width: "100%",
        height: "100%",
        position: "absolute",
        overflow: "scroll",
        paddingHorizontal: 12,
        top: 0,
        bottom: 0,
        zIndex: -1
    }}>
        <ScrollView contentContainerStyle={{flexGrow: 1}} style={{paddingTop: headerHeight, paddingBottom: 80}}>
            <ColumnSpace/>
            {props.children}
        </ScrollView>
    </View>;
}

function OrderItemRow(props: { orderItem: OrderItem, index: number }) {
    const colors = Colors.instance(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);

    return <View style={{
        width: "100%"
    }}>
        <View style={{flexDirection: "row", alignItems: "center", paddingVertical: 10}}>
            <Text style={{flexGrow: 1, flexBasis: 0, alignItems: "center", justifyContent: "center", textAlign: "center"}}
                  color={colors.get("highConText") as string}
                  weight={700}
                  size={13}>{`${props.index + 1}`}</Text>
            <Text style={{flexGrow: 4, flexBasis: 0, alignItems: "center", justifyContent: "center", textAlign: "right"}}
                  color={colors.get("highConText") as string}
                  weight={600}
                  size={13}>{props.orderItem.product.fullName}</Text>
            <Text style={{flexGrow: 2, flexBasis: 0, alignItems: "center", justifyContent: "center", textAlign: "center"}}
                  color={colors.get("highConText") as string}
                  weight={600}
                  size={13}>{`${props.orderItem.product.priceWithDiscount}`}</Text>
            <Text style={{flexGrow: 1, flexBasis: 0, alignItems: "center", justifyContent: "center", textAlign: "center"}}
                  color={colors.get("highConText") as string}
                  weight={600}
                  size={13}>{`${props.orderItem.count}`}</Text>
            <Text style={{flexGrow: 2, flexBasis: 0, alignItems: "center", justifyContent: "center", textAlign: "center"}}
                  color={colors.get("highConText") as string}
                  weight={600}
                  size={13}>{`${props.orderItem.price}`}</Text>
        </View>
    </View>
}

function HeaderRow() {

    return <View style={{
        width: "100%"
    }}>
        <View style={{flexDirection: "row", alignItems: "center", backgroundColor: "#000", paddingVertical: 6}}>
            <Text style={{flexGrow: 1, flexBasis: 0, alignItems: "center", justifyContent: "center", textAlign: "center"}}
                  color="#fff"
                  weight={700}
                  size={13}>#</Text>
            <Text style={{flexGrow: 4, flexBasis: 0, alignItems: "center", justifyContent: "center", textAlign: "right"}}
                  color="#fff"
                  size={13}>نام محصول</Text>
            <Text style={{flexGrow: 2, flexBasis: 0, alignItems: "center", justifyContent: "center", textAlign: "center"}}
                  color="#fff"
                  size={13}>فی</Text>
            <Text style={{flexGrow: 1, flexBasis: 0, alignItems: "center", justifyContent: "center", textAlign: "center"}}
                  color="#fff"
                  size={13}>تعداد</Text>
            <Text style={{flexGrow: 2, flexBasis: 0, alignItems: "center", justifyContent: "center", textAlign: "center"}}
                  color="#fff"
                  size={13}>قیمت کل</Text>
        </View>
    </View>
}

